import type {IFilter} from "@/core/entity/IFilter";
import {ISearchFilter} from "@/core/entity/ISearchFilter";
import {TAG_COLOR} from "@/core/config/Constant";

export function generatorQueryString(term: IFilter): string {
  let queryStr = '';
  if (term) {
    Object.keys(term).forEach(key => {
      if (term[key]) {
        if (key === 'paginationPage') {
          queryStr += `&offset=${(term.paginationPage - 1) * term.paginationSize}`;
        } else if (key === 'paginationSize') {
          queryStr += `&max=${term[key]}`;
        } else if (key === 'key') {
          const temp = term[key];
          Object.keys(temp).forEach(k => {
            queryStr += `&${k}=${temp[k]}`;
          });
        }
      }
    });
  }
  return queryStr;
}


export function generateSearchString(filter: ISearchFilter) {
  let queryStr = '';
  if (filter.query) {
    let e = "&q="
    for (const q of filter.query) {
      const value = q.value !== undefined ? q.value.toString().trim() : ''
      e += q.column + ":" + q.operator + ":" + value + "!"
    }
    queryStr += e;
  }
  if (filter.entity) {
    queryStr += "&e=" + filter.entity;
  }
  if (filter.fields) {
    queryStr += "&f=" + filter.fields.join(",")
  }

  if (filter.expands) {
    queryStr += "&ep=" + filter.expands.join(",")
  }

  queryStr += `&p=offset:${(filter.paginationPage - 1) * filter.paginationSize}!size:${filter.paginationSize}!sort:dateCreated:desc`
  return queryStr;
}

export function generateString(filter: any) {
  if (filter == undefined) return '';
  let queryStr = '';
  Object.keys(filter).forEach(key => {
    queryStr += `&${key}=${filter[key]}`;
  });
  return queryStr;
}


export function buildFormData(data: any) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    if (data[key]) formData.set(key, data[key])
  });
  return formData;
}

export function exchangeRate(rate: number, amount: number, isReduce: boolean) {
  if (!isReduce) return rate * amount;
  const revertRate = 1 / rate;
  return amount * revertRate;
}


export function makeDownloadLink(data) {
  const fileName = data.headers["content-disposition"].split("filename=")[1];
  const blob = new Blob([data.data], {type: data.headers['content-type']});
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  const decodeName=  decodeFilename(fileName)
  link.setAttribute('download', decodeName); //or any other extension
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export function activeMenu(menu, item) {
  menu.forEach(a => {
    if (menu.includes(item))
      a.active = false;
    if (!a.children) return;
    a.children.forEach(b => {
      if (a.children.includes(item)) {
        b.active = false
      }
      if (!b.children) return false;
      b.children.forEach(c => {
        if (b.children.includes(item)) {
          c.active = false
        }
      })
    })
  });
}


export function buildTerm(filter: any) {
  let terms = '';
  if (filter.npi) {
    terms += '+' + filter.npi;
  }
  if (filter.name) {
    terms += '+' + filter.name;
  }
  if (filter.line1) {
    terms += '+' + filter.line1;
  }
  if (filter.city) {
    terms += '+' + filter.city;
  }
  if (filter.country) {
    terms += '+' + filter.country;
  }
  return terms;
}


export function buildTagColor(color) {
  const c = TAG_COLOR.find(item => item.name === color);
  return c ? c.hex : '';
}
export function findAddressComponent(type, components) {
  for (const component of components) {
    if (component.componentType === type) {
      return component.componentName.text; // Return longName or shortName based on your need
    }
  }
}


export function decodeFilename(encoded: string): string {
  try {
    // Handle form-encoded strings (+ to space) then percent decode
    return decodeURIComponent(encoded.replace(/\+/g, ' '));
  } catch (error) {
    return encoded;
  }

}

export function buildClaimFormTerm(type) {
  if (type === "lostBaggage") {
    return "This is to provide Trident Global Assistance authorization to obtain, recover and forward information, payments and/or obtain recovery from your Credit Card, Extended Health benefits company, Airlines and/or other sources on your behalf.\n\n1. I hereby assign, to Trident Global Assistance, any claim or right of action I may have against any person, company or organization for the loss or expense that has been paid to me by Trident Global Assistance. This assignment includes but is not limited to any rights I may have for any full or partial refund, credit or other benefit that maybe available to me from any person, company or organization including but not limited to any airline, travel provider, tour operator, travel company and/or credit card company. I further agree to cooperate with Trident Global Assistance in its efforts to enforce my rights as against any other party and agree that Trident Global Assistance may, in relation to the rights I am assigning to them, commence a legal action in my name as against any other party at its own expense. If I recover against any third party, I agree to hold in trust sufficient funds to reimburse Trident Global Assistance for the amount of the loss or expense it paid to me. I hereby direct that any payment from any person, company or organization in relation to any claim, right of action, refund, credit or other benefit which I have hereby assigned, shall be made payable to Trident Global Assistance. A copy of this assignment and direction shall have the same authority as the original.\n\n2. I understand my claim may be subject to review and investigation and I give Trident Global Assistance or their authorized agents authority to acquire any documents or statements from other insurers, financial institutions, travel suppliers, any company or public/private organization which can provide information related to my claim, and I hereby consent to the disclosure of such information by Trident Global Assistance to other sources as may be required for the processing of my claim.\n\n3. I authorize you to give Trident Global Assistance any and all information required for the adjudication and processing of my claim. I hereby consent to the disclosure of such information by Trident Global Assistance to other sources as may be required for the processing of my claim for benefits obtainable from other sources."
  }
  return "This is to provide Trident Global Assistance authorization to obtain, recover and forward information, payments and/or obtain recovery from your Credit Card, Extended Health benefits company, Airlines and/or other sources on your behalf.\n\n1. I hereby assign, to Trident Global Assistance, any claim or right of action I may have against any person, company or organization for the loss or expense that has been paid to me by Trident Global Assistance. This assignment includes but is not limited to any rights I may have for any full or partial refund, credit or other benefit that maybe available to me from any person, company or organization including but not limited to any airline, travel provider, tour operator, travel company and/or credit card company. I further agree to cooperate with Trident Global Assistance in its efforts to enforce my rights as against any other party and agree that Trident Global Assistance may, in relation to the rights I am assigning to them, commence a legal action in my name as against any other party at its own expense. If I recover against any third party, I agree to hold in trust sufficient funds to reimburse Trident Global Assistance for the amount of the loss or expense it paid to me. I hereby direct that any payment from any person, company or organization in relation to any claim, right of action, refund, credit or other benefit which I have hereby assigned, shall be made payable to Trident Global Assistance. A copy of this assignment and direction shall have the same authority as the original.\n\n2. I understand my claim may be subject to review and investigation and I give Trident Global Assistance or their authorized agents authority to acquire any documents or statements from other insurers, financial institutions, travel suppliers, any company or public/private organization which can provide information related to my claim, and I hereby consent to the disclosure of such information by Trident Global Assistance to other sources as may be required for the processing of my claim.\n\n3. I authorize you to give Trident Global Assistance any and all information you have regarding me, while under observation or treatment by you, including my medical history, diagnoses and test results, and I hereby consent to the disclosure of such information by Trident Global Assistance to other sources as may be required for the processing of my claim for benefits obtainable from other sources."
}